import React from 'react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from 'recharts';

const COLORS = ['#FF470F', '#440631', '#1FA3F0', '#259D92', '#EC9F00', '#FD8950', '#701251'];

function CustomTooltip({ active, payload, label, tooltipFormatter }) {
    if (!active || !payload || payload.length === 0) return null;

    return (
        <div style={{
            backgroundColor: '#fff',
            border: '1px solid #ddd',
            borderRadius: '4px',
            padding: '10px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
            <p style={{ margin: '0 0 5px', fontWeight: 'bold' }}>{label}</p>
            {payload.map((entry, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center', margin: '3px 0' }}>
                    <span style={{
                        display: 'inline-block',
                        width: '10px',
                        height: '10px',
                        borderRadius: '2px',
                        backgroundColor: entry.color,
                        marginRight: '6px'
                    }} />
                    <span>{entry.name}: {tooltipFormatter ? tooltipFormatter(entry.value) : entry.value}</span>
                </div>
            ))}
        </div>
    );
}

const FONT_SIZE = 11;

export function SimpleLineChart({ data, dimensionKey, metricKeys, height = 300, tooltipFormatter }) {
    if (!data || data.length === 0) return null;

    const yAxisFormatter = tooltipFormatter || ((v) => v);

    return (
        <ResponsiveContainer width="100%" height={height}>
            <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                <CartesianGrid stroke="#e0e0e0" strokeDasharray="3 3" />
                <XAxis dataKey={dimensionKey} tick={{ fontSize: FONT_SIZE }} />
                <YAxis tickFormatter={yAxisFormatter} tick={{ fontSize: FONT_SIZE }} width={100} />
                <Tooltip content={<CustomTooltip tooltipFormatter={tooltipFormatter} />} />
                <Legend wrapperStyle={{ fontSize: FONT_SIZE }} />
                {metricKeys.map((key, index) => (
                    <Line
                        key={key}
                        type="monotone"
                        dataKey={key}
                        stroke={COLORS[index % COLORS.length]}
                        dot={{ r: 4 }}
                        activeDot={{ r: 6 }}
                    />
                ))}
            </LineChart>
        </ResponsiveContainer>
    );
}
